import { queryOptions } from '@tanstack/react-query';
import { getBrands } from '~/apis/mdms';

export const brandsQueryOptions = (params: Parameters<typeof getBrands>[0]) => {
  return queryOptions({
    queryKey: ['brands', { ...params }],
    queryFn: () => getBrands(params),
    select: (data) => data?.data,
    placeholderData: (data) => data,
    staleTime: Infinity,
  });
};
